import React, { FC } from 'react';
import { RecruiterLanding } from '../recruiter/RecruiterLanding/RecruiterLanding';
import { CandidateLayout } from '../../layout/candidate/CandidateLayout';
import { CandidateHomeData } from '../../page-components/home/HomePage';

export const RecruiterGuestView: FC<{ data: CandidateHomeData }> = (props) => {
  return (
    <CandidateLayout title={'Start Recruiting Today'} hideRecruiterButton={true}>
      <RecruiterLanding data={props.data} />
    </CandidateLayout>
  );
};
